module.exports = __webpack_public_path__ + "img/nerlynx-tablets.de2e516a.png";